import { useLayoutEffect } from 'react';

import { twMerge } from 'tailwind-merge';

import { useAdmin } from '@/_providers/administration';
import { useCurrentLocation } from '@/_shared';

export function ContainerLayout({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const { matched } = useCurrentLocation();
  const widthCtrl = useAdmin();

  useLayoutEffect(() => {
    widthCtrl[1]((s) => ({ ...s, isFullWidth: Boolean(matched?.staticData?.isFullWidth) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matched?.staticData?.isFullWidth]);

  return (
    <main
      className={twMerge(
        'flex w-full flex-1 flex-col pb-10',
        matched?.staticData?.isFullWidth && '3xl:max-w-480 4xl:max-w-480',
        className
      )}
    >
      {children}
    </main>
  );
}
